export enum VerifyTypeEnum {
  PIC = 'PIC',
  BANK = 'BANK',
  GOS_KEY = 'GOS_KEY',
  TINKOF_ID = 'TINKOF_ID',
  QES = 'QES',
  REQUISITES = 'REQUISITES',
  REQUISITES_IP = 'REQUISITES_IP',
}
